<template>
<tooltip
    v-if="tooltip"
    :id="tooltip.id"
    :label="tooltip.label" />
</template>

<script>
import { mapState } from "vuex";
import { MDCTooltip } from "@material/tooltip";
import Tooltip from "@/components/mdc/Tooltip";

export default {
    components: { Tooltip },
    computed: mapState({
        tooltip: state => state.tooltip
    }),
    watch: {
        async tooltip(tooltip) {
            if (!tooltip) {
                this.instance = null;
            } else {
                await this.$nextTick();
                this.instance = new MDCTooltip(this.$el);
                this.instance.foundation.show();
            }
        }
    }
};
</script>
